/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Stock_Out_Lot_AvailableInputs */

const vi_stock_out_lot_available = /** @type {(inputs: Stock_Out_Lot_AvailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tồn ${i?.qty} ${i?.unit}`)
};

/**

* @param {Stock_Out_Lot_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_lot_available = /** @type {((inputs: Stock_Out_Lot_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Lot_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_lot_available(inputs)
});